import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { Package } from '../../../../packages/package'
import { TerminalWorkBatchCtx } from '../terminal-work-batch-ctx'
import { PackageService } from '../../../../packages/package.service'
import { BehaviorSubject } from 'rxjs'
import { ElderToastService } from '@elderbyte/ngx-starter'
import { TerminalBatchPackageDetailComponent } from '../terminal-batch-package-detail/terminal-batch-package-detail.component'
import { AsyncPipe } from '@angular/common'

export interface ITerminalPackageDialogOptions {
  readonly pkgId: string
  readonly terminalBatchCtx: TerminalWorkBatchCtx
}

@Component({
  selector: 'app-terminal-batch-package-detail-dialog',
  templateUrl: './terminal-batch-package-detail-dialog.component.html',
  styleUrls: ['./terminal-batch-package-detail-dialog.component.scss'],
  imports: [TerminalBatchPackageDetailComponent, AsyncPipe],
})
export class TerminalBatchPackageDetailDialogComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly pkg$ = new BehaviorSubject<Package>(null)
  public readonly terminalBatchCtx: TerminalWorkBatchCtx
  private dialogRef = inject<MatDialogRef<TerminalBatchPackageDetailDialogComponent>>(MatDialogRef)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const data = inject<ITerminalPackageDialogOptions>(MAT_DIALOG_DATA)
    const packageService = inject(PackageService)
    const toast = inject(ElderToastService)
    packageService.findById(data.pkgId).subscribe({
      next: (pkg) => this.pkg$.next(pkg),
      error: (err) => toast.error('Failed to load package with id: ' + data.pkgId, err),
    })
    this.terminalBatchCtx = data.terminalBatchCtx
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public close(): void {
    this.dialogRef.close()
  }
}
